<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <member-level-table></member-level-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import memberLevelTable from './MemberLevelTable.vue'

  export default {
    name: 'memberLevel',
    components: {memberLevelTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/memberLevel/MemberLevel.vue